import React, { useState, useRef } from "react";
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    Grid,
    Divider,
    Snackbar,
    Alert,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import axios from '../api/axiosConfig';
// import { Today } from "@mui/icons-material";

const genderOptions = [
    { value: null, label: 'Pilih Jenis Kelamin' },
    { value: 'L', label: 'Laki-laki' },
    { value: 'P', label: 'Perempuan' },
];

const isBetaniaMemberOptions = [
    { value: null, label: 'Pilih Status Member' },
    { value: '1', label: 'Member Betania' },
    { value: '0', label: 'Non Member' },
];

export default function NewMember() {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";
    const formRef = useRef(null);

    const [apiResponse, setApiResponse] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [toast, setToast] = useState({
        open: false,
        severity: "success",
        message: "",
    });
    // const [search, setSearch] = useState("");


    const defForm = {
        name_full: "",
        name_nick: "",
        gender: "",
        phone_mobile: "",
        lahir_tempat: "",
        lahir_date: "",
        alamat: "",
        isbetaniamember: "",
        betaniamemberestablished: "",
    }

    const [form, setForm] = useState({
        name_full: "",
        name_nick: "",
        gender: "",
        phone_mobile: "",
        lahir_tempat: "",
        lahir_date: "",
        alamat: "",
        isbetaniamember: "",
        betaniamemberestablished: "",
    });

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
        if (errors[e.target.name]) {
            setErrors((prev) => ({
                ...prev,
                [e.target.name]: "",
            }));
        }
    };

    const focusFirstError = (nextErrors) => {
        const order = [
            "name_full",
            "gender",
            "phone_mobile",
            "isbetaniamember",
            "betaniamemberestablished",
        ];
        const firstKey = order.find((key) => nextErrors[key]);
        if (!firstKey) return;
        requestAnimationFrame(() => {
            const el = formRef.current?.querySelector(`[name="${firstKey}"]`);
            el?.focus?.();
        });
    };

    const validateForm = () => {
        const nextErrors = {};
        if (!form.name_full) nextErrors.name_full = "Nama lengkap wajib diisi.";
        if (!form.gender) nextErrors.gender = "Pilih jenis kelamin.";
        if (!form.phone_mobile) nextErrors.phone_mobile = "Nomor telepon wajib diisi.";
        if (!form.isbetaniamember) nextErrors.isbetaniamember = "Pilih status member.";
        if (form.isbetaniamember === "1" && !form.betaniamemberestablished) {
            nextErrors.betaniamemberestablished = "Tanggal bergabung wajib diisi.";
        }
        setErrors(nextErrors);
        focusFirstError(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            setToast({
                open: true,
                severity: "error",
                message: "Periksa kembali kolom yang wajib diisi.",
            });
            return;
        }

        var strForm = JSON.stringify(form);
        console.log("Submitting form data:", strForm);
        try {
            setLoading(true);

            const url = `/jemaat.php`;

            const resp = await axios.post(url, form, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("Response from server:", resp.data);
            setApiResponse(resp.data);

            if (resp.data && resp.data.success === true) {
                setToast({
                    open: true,
                    severity: "success",
                    message: `Member berhasil ditambahkan! ID: ${resp.data.id}`,
                });
                setForm(defForm);
            } else {
                setToast({
                    open: true,
                    severity: "error",
                    message:
                        "Gagal menambahkan member. Pastikan semua kolom sudah diisi lengkap. " +
                        (resp.data && resp.data.message ? resp.data.message : ""),
                });
            }
        } catch (err) {
            console.error("Error submitting data:", err);
            setToast({
                open: true,
                severity: "error",
                message: "Terjadi kesalahan saat menyimpan data.",
            });
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        setForm(defForm);
        setErrors({});
        setToast({
            open: true,
            severity: "success",
            message: "Form telah direset.",
        });
    };

    return (
        <Box
            sx={{
                width: "100%",
                p: { xs: 1.5, md: 3 },
            }}
        >
            {/* Page Title */}
            <Box sx={{ mb: 3 }}>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 800,
                        color: isDark ? "#f8fafc" : "#0f172a",
                    }}
                >
                    Tambahkan Anggota Baru
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    Lengkapi data anggota dengan format yang benar untuk mempercepat verifikasi.
                </Typography>
            </Box>

            <Paper
                elevation={0}
                sx={{
                    mx: "auto",
                    p: { xs: 2, md: 4 },
                    borderRadius: 4,
                    border: "1px solid",
                    borderColor: isDark ? alpha("#ffffff", 0.08) : "#e2e8f0",
                    background: isDark
                        ? "linear-gradient(180deg, rgba(15,23,42,0.95), rgba(2,6,23,0.95))"
                        : "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
                    boxShadow: isDark
                        ? "0 12px 32px rgba(0,0,0,0.45)"
                        : "0 12px 32px rgba(15,23,42,0.08)",
                }}
            >
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" fontWeight={700}>
                        Informasi Utama
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Pastikan data identitas sesuai dokumen.
                    </Typography>
                </Box>
                <Grid container spacing={3} ref={formRef}>
                    {/* Nama */}
                    <Grid size={{ xs: 12, md: 6 }}  >
                        <TextField
                            label="Nama Lengkap"
                            name="name_full"
                            value={form.name_full}
                            onChange={handleChange}
                            fullWidth
                            required
                            error={Boolean(errors.name_full)}
                            helperText={errors.name_full || "Gunakan nama sesuai identitas."}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }} >
                        <TextField
                            label="Nama Panggilan"
                            name="name_nick"
                            value={form.name_nick}
                            onChange={handleChange}
                            fullWidth
                            helperText="Opsional"
                        />
                    </Grid>

                    {/* Gender */}
                    <Grid size={{ xs: 12, md: 4 }}  >
                        <TextField
                            select
                            label="Jenis Kelamin"
                            name="gender"
                            value={form.gender}
                            onChange={handleChange}
                            fullWidth
                            SelectProps={{ native: true }}
                            error={Boolean(errors.gender)}
                            helperText={errors.gender || ""}
                        >
                            {genderOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </TextField>
                    </Grid>

                    {/* Phone */}
                    <Grid size={{ xs: 12, md: 4 }} >
                        <TextField
                            label="Nomor Telepon"
                            name="phone_mobile"
                            value={form.phone_mobile}
                            onChange={handleChange}
                            fullWidth
                            error={Boolean(errors.phone_mobile)}
                            helperText={errors.phone_mobile || "Format: 08xxxxxxxxxx"}
                        />
                    </Grid>

                    {/* Status */}
                    <Grid size={{ xs: 12, md: 4 }}  >
                        <TextField
                            select
                            label="Status Member"
                            name="isbetaniamember"
                            value={form.isbetaniamember}
                            onChange={handleChange}
                            fullWidth
                            SelectProps={{ native: true }}
                            error={Boolean(errors.isbetaniamember)}
                            helperText={errors.isbetaniamember || ""}
                        >
                            {isBetaniaMemberOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </TextField>
                    </Grid>

                    {/* Divider */}
                    <Grid size={{ xs: 12 }}>
                        <Divider sx={{ my: 1.5 }} />
                        <Typography sx={{ fontWeight: 700 }}>
                            Informasi Kelahiran
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Data lahir diperlukan untuk keperluan administrasi.
                        </Typography>
                    </Grid>

                    {/* Birth */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextField
                            label="Tempat Lahir"
                            name="lahir_tempat"
                            value={form.lahir_tempat}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextField
                            label="Tanggal Lahir"
                            name="lahir_date"
                            type="date"
                            value={form.lahir_date}
                            onChange={handleChange}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    {/* Address */}
                    <Grid size={{ xs: 12 }} >
                        <TextField
                            label="Alamat Lengkap"
                            name="alamat"
                            value={form.alamat}
                            onChange={handleChange}
                            fullWidth
                            multiline
                            minRows={3}
                            helperText="Cantumkan alamat domisili saat ini."
                        />
                    </Grid>

                    {/* Betania Join Date */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextField
                            label="Tanggal Bergabung Betania"
                            name="betaniamemberestablished"
                            type="date"
                            value={form.betaniamemberestablished}
                            onChange={handleChange}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            error={Boolean(errors.betaniamemberestablished)}
                            helperText={errors.betaniamemberestablished || ""}
                        />
                    </Grid>
                </Grid>
            </Paper>
            {/* Sticky Action Bar */}
            <Box
                sx={{
                    position: "sticky",
                    bottom: 0,
                    mt: 3,
                    zIndex: 10,
                    background: isDark
                        ? "linear-gradient(180deg, rgba(2,6,23,0), rgba(2,6,23,0.9))"
                        : "linear-gradient(180deg, rgba(248,250,252,0), rgba(248,250,252,0.95))",
                    pb: 2,
                    pt: 2,
                }}
            >
                <Paper
                    elevation={0}
                    sx={{
                        p: 2,
                        borderRadius: 3,
                        border: "1px solid",
                        borderColor: isDark ? alpha("#ffffff", 0.08) : "#e2e8f0",
                        background: isDark ? "#0f172a" : "#ffffff",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 2,
                    }}
                >
                    <Button
                        variant="outlined"
                        size="large"
                        onClick={handleReset}
                        disabled={loading}
                        sx={{
                            px: 3,
                            fontWeight: 600,
                            borderRadius: 2,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleSubmit}
                        disabled={loading}
                        sx={{
                            px: 4,
                            fontWeight: 600,
                            borderRadius: 2,
                            background: "linear-gradient(90deg,#2563eb,#1d4ed8)",
                            boxShadow: "0 10px 22px rgba(37,99,235,0.3)",
                        }}
                    >
                        Save Member
                    </Button>
                </Paper>
            </Box>
            <Snackbar
                open={toast.open}
                autoHideDuration={4000}
                onClose={() => setToast((prev) => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={() => setToast((prev) => ({ ...prev, open: false }))}
                    severity={toast.severity}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {toast.message}
                </Alert>
            </Snackbar>
        </Box>

    );
}
